module.exports = __webpack_public_path__ + "static/coqui_license_explainer-5649811c26c0f9db09db6fc8843612b8.mp4";